import type { ReactNode } from 'react';
import { cx } from '../lib/cx';

interface CardProps {
  title?: string;
  /** Figure shown alongside the title: square feet, a count, a dollar range. */
  figure?: string;
  children?: ReactNode;
  footer?: ReactNode;
  className?: string;
}

/** 14px radius, grey-200 hairline, the Smart Home shadow-sm. */
export default function Card({ title, figure, children, footer, className }: CardProps) {
  return (
    <div className={cx('rounded-lg border border-grey-200 bg-white shadow-sm', className)}>
      {(title || figure) && (
        <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 border-b border-grey-200 px-6 py-5">
          {title && <h3 className="t-h3 text-ink">{title}</h3>}
          {figure && <p className="t-numeral text-lg text-green-700">{figure}</p>}
        </div>
      )}
      {children && <div className="t-body measure px-6 py-5 text-grey-600">{children}</div>}
      {footer && <div className="border-t border-grey-200 px-6 py-5">{footer}</div>}
    </div>
  );
}
